import { useField } from 'formik';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { tokens } from '@treams/treams-ui';

import type { TalentReviewCellColors } from '../../talent-reviews/v2/talentReviewColors';
import TalentReviewLabel from './TalentReviewLabel';
import TalentReviewNorm from './TalentReviewNorm';

const Container = styled(Box)`
	margin-left: 10px;
`;

const CellToolbar = styled(Box)`
	position: absolute;
	top: 100%;
	transform: translateY(-50%);
	background: white;
`;

const CellToolbarUp = styled(Box)`
	height: 50%;
	width: 100%;
	background: ${tokens.surface.secondary};
	position: absolute;
`;

const CellContainer = styled(Flex)<{ hex: string; $labelHex: string }>`
	flex-grow: 0;
	flex-shrink: 0;
	background: ${tokens.surface.secondary};
	width: 160px;
	min-height: 120px;
	border-radius: 6px;
	position: relative;
	color: ${(props) => props.$labelHex};

	align-items: center;
	justify-content: center;

	border: 2px solid ${(props) => props.hex};
`;

const Instruction = styled(Flex)`
	margin-top: 20px;
	justify-content: center;

	color: ${tokens.text.secondary};
`;

export default function TalentReviewCell(props: { name: string; colors: TalentReviewCellColors }) {
	const [{ value: hasNorm }] = useField<boolean>('hasNorm');
	const hex = props.colors.border;
	const labelHex = props.colors.label;

	return (
		<Container>
			<CellContainer hex={hex} $labelHex={labelHex}>
				{hasNorm && <TalentReviewNorm name={props.name + '.norm'} hex={labelHex} />}

				<CellToolbar>
					<CellToolbarUp />
					<Box style={{ position: 'relative' }}>
						<TalentReviewLabel hex={labelHex} name={props.name + '.label'} />
					</Box>
				</CellToolbar>
			</CellContainer>
			<Instruction>
				<TalentReviewLabel
					multiline
					hex={tokens.text.secondary}
					name={props.name + '.instruction'}
				/>
			</Instruction>
		</Container>
	);
}
